import React from 'react';
import { Field } from 'formik';
import { File as FileField } from '../../form';

const File = ({
  label,
  accept,
  onChange,
  inputRest,
  ...rest
}) => (
  <Field {...rest}>
    {({ field, form }) => {
      const onChangeCustom = (e) => {
        const { target: { files } } = e;
        if (files.length) {
          form.setFieldValue(field.name, files[0]);
          if (onChange) {
            onChange(e);
          }
        }
      };

      return (
        <FileField
          {...field}
          {...inputRest}
          accept={accept}
          label={label}
          onChange={onChangeCustom}
        />
      );
    }}
  </Field>
);

export default File;
